import 'css-chunk:src/applications/ProductFulfillmentApp/CreatorProductSelection/components/OrderRequestReview/components/SearchResults/SearchResults.module.scss';export default {
  "searchResultsCard": "_searchResultsCard_174sv_1",
  "stickyFooter": "_stickyFooter_174sv_1",
  "searchIcon": "_searchIcon_174sv_8",
  "divider": "_divider_174sv_11",
  "mainSection": "_mainSection_174sv_14",
  "emptyText": "_emptyText_174sv_19",
  "listContainer": "_listContainer_174sv_22",
  "firstColumn": "_firstColumn_174sv_25"
};